import { render, staticRenderFns } from "./RoundPlanner.vue?vue&type=template&id=2d84edbc&scoped=true"
import script from "./RoundPlanner.vue?vue&type=script&lang=js"
export * from "./RoundPlanner.vue?vue&type=script&lang=js"
import style0 from "./RoundPlanner.vue?vue&type=style&index=0&id=2d84edbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84edbc",
  null
  
)

export default component.exports